export default{
    computed: {
        headerMenu() {
            return this.$store.state.site_data.header_menu;
        },
        footerMenu() {
            return this.$store.state.site_data.footer_menu;
        }
    }
}